"use client";

import { c as _c } from "react/compiler-runtime";
import { ImageFeatureCarousel } from "@/components/features/image-feature-carousel";
import type { ImageFeatureCarouselLogo } from "@/components/features/image-feature-carousel";
import { LayoutHeader } from "@/components/common/layout-header";
import type { PagebuilderType, VisualType } from "@/lib/types";
import { getI18nString, nullToUndefined } from "@/lib/utils";
import { useLocale } from "next-intl";
import type { Locale } from "@/i18n/config";
export type FeatureImageCardBlockProps = PagebuilderType<"featureImageCard">;
export function FeatureImageCardBlock(t0) {
  const $ = _c(13);
  const {
    layout
  } = t0;
  const locale = useLocale() as Locale;
  if (!layout) {
    return null;
  }
  const rawCards = "imageFeatureCards" in layout ? layout.imageFeatureCards : undefined;
  if (!rawCards || rawCards.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== locale || $[1] !== rawCards) {
    let t2;
    if ($[3] !== locale) {
      t2 = card_0 => ({
        key: card_0.key,
        headline: getI18nString(card_0.headline, "", locale) || "",
        bodyCopy: nullToUndefined(card_0.bodyCopy),
        image: nullToUndefined(card_0.image) as VisualType | undefined,
        colour: nullToUndefined(card_0.colour),
        logo: nullToUndefined(card_0.logo) as ImageFeatureCarouselLogo | undefined
      });
      $[3] = locale;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = rawCards.filter(_temp).map(t2);
    $[0] = locale;
    $[1] = rawCards;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cards = t1;
  let t2;
  if ($[5] !== layout || $[6] !== locale) {
    t2 = <LayoutHeader item={layout} locale={locale} />;
    $[5] = layout;
    $[6] = locale;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== cards) {
    t3 = <ImageFeatureCarousel cards={cards} />;
    $[8] = cards;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <section data-testid="feature-image-card-block">{t2}{t3}</section>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(card) {
  return card.key;
}